import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { defaultSupportEmail } from '../app.component';


@Component({
    selector: 'app-admin-modal',
    templateUrl: './welcome-admin.component.html',
    standalone: false
})
export class WelcomeAdminComponent {
  @Input() isOpen?: BehaviorSubject<boolean>;
  @Input() isVerified?: BehaviorSubject<boolean>;
  adminAuthForm: FormGroup = new FormGroup({});
  showPassword: boolean;
  supportEmail = defaultSupportEmail;

  constructor(private router: Router, private readonly fb: FormBuilder, private http: HttpClient) {
    this.showPassword = false;
    this.adminAuthForm = fb.group({
        password: [ '', [ Validators.required, Validators.maxLength(64)] ]
    });
    let adminPassword = this.adminAuthForm.get('password');
    if(adminPassword) {
      adminPassword.valueChanges.subscribe(() => {
        this.invalidError.next(false);
      });
    }
  }

  invalidError = new BehaviorSubject(false);
  existingSessionError = new BehaviorSubject(false);
  maxAttemptsError = new BehaviorSubject(false);
  loginCounter = 4;

  continue(): void {
    if(this.isOpen){
      this.isOpen.next(false);
    }
    else {
      this.isOpen = new BehaviorSubject<boolean>(false);
    }
  }

  password() {
    this.showPassword = !this.showPassword;
  }

  submit(): void {
    this.http.post(
      '/api/session/polling_station',
      {id: this.adminAuthForm.controls.password.value},
      { observe: 'body', withCredentials: true }
    ).subscribe({
      next: () => {
        this.invalidError.next(false);
        this.existingSessionError.next(false);
        this.continue();
      },
      error: (err) => {
        if(err.error.error_type === 'INVALID_IDENTITY') {
          this.invalidError.next(true);
          this.setLoginCounter();
        }
        else if (err.error.error_type === 'DUPLICATE_SESSION') {
          this.existingSessionError.next(true);
        }
      },
    });
  }

  setLoginCounter() {
    this.loginCounter -= 1;
    localStorage.setItem('logCount', this.loginCounter.toString());

    if (this.loginCounter === 0) {
      this.maxAttemptsError.next(true);
      this.invalidError.next(false);
    }
  }
}
